"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactLeaflet = require("react-leaflet");

var _leaflet = _interopRequireDefault(require("leaflet"));

var _geolib = require("geolib");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

var ReactLeafletMultiOptionsPolyline =
/*#__PURE__*/
function (_React$Component) {
  _inherits(ReactLeafletMultiOptionsPolyline, _React$Component);

  function ReactLeafletMultiOptionsPolyline(props) {
    var _this;

    _classCallCheck(this, ReactLeafletMultiOptionsPolyline);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(ReactLeafletMultiOptionsPolyline).call(this, props));
    _this.mapPositions = _this.mapPositions.bind(_assertThisInitialized(_this));
    _this.state = {
      lines: _this.mapPositions()
    };
    _this.getBounds = _this.getBounds.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(ReactLeafletMultiOptionsPolyline, [{
    key: "mapPositions",
    value: function mapPositions() {
      var _this$props = this.props,
          positions = _this$props.positions,
          optionIdxFn = _this$props.optionIdxFn,
          options = _this$props.options;
      var lines = new Array(options.length);
      var currentLine = new Array(options.length);

      for (var idx = 0; idx < options.length; ++idx) {
        currentLine[idx] = [];
        lines[idx] = [];
      }

      var last;
      var lastLineIdx = 0;
      var currentLineIdx = 0;

      for (var _idx = 1; _idx < positions.length; ++_idx) {
        var item = positions[_idx];
        var previous = positions[_idx - 1];
        var coordinates = new _leaflet["default"].LatLng(item.lat, item.lng);
        currentLineIdx = optionIdxFn(item, previous, _idx, positions);
        currentLine[currentLineIdx].push(coordinates); // If 1st item, must handle item at index 0;

        if (_idx === 1) {
          last = previous;
          lastLineIdx = optionIdxFn(previous, previous, _idx - 1, positions);
          currentLine[lastLineIdx].push(last);

          if (lastLineIdx !== currentLineIdx) {
            currentLine[lastLineIdx].push(coordinates);
            lines[lastLineIdx].push(currentLine[lastLineIdx]);
            currentLine[lastLineIdx] = [];
          }
        } else {
          // If the result of optionIdxFn from last is different from current, push last line and clear it;
          if (lastLineIdx !== currentLineIdx) {
            currentLine[lastLineIdx].push(coordinates);
            lines[lastLineIdx].push(currentLine[lastLineIdx]);
            currentLine[lastLineIdx] = [];
          }
        } // Keep index and item


        lastLineIdx = currentLineIdx;
        last = item;
      } // Push last items;


      lines[currentLineIdx].push(currentLine[currentLineIdx]);
      return lines;
    }
  }, {
    key: "shouldComponentUpdate",
    value: function shouldComponentUpdate(nextProps, nextState) {
      return nextProps !== this.props;
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState, snapshot) {
      this.setState({
        lines: this.mapPositions()
      });
    }
  }, {
    key: "getBounds",
    value: function getBounds() {
      var bounds = (0, _geolib.getBounds)(this.props.positions);
      return new _leaflet["default"].LatLngBounds(new _leaflet["default"].LatLng(bounds.maxLat, bounds.minLng), new _leaflet["default"].LatLng(bounds.minLat, bounds.maxLng));
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      return _react["default"].createElement(_reactLeaflet.FeatureGroup, null, this.state.lines.map(function (optionsLine, optionsIdx) {
        return optionsLine.map(function (line, idx) {
          return _react["default"].createElement(_reactLeaflet.Polyline, _extends({
            key: idx
          }, _this2.props, {
            positions: line
          }, _this2.props.options[optionsIdx]));
        });
      }));
    }
  }]);

  return ReactLeafletMultiOptionsPolyline;
}(_react["default"].Component);

exports["default"] = ReactLeafletMultiOptionsPolyline;
ReactLeafletMultiOptionsPolyline.propTypes = {
  positions: _propTypes["default"].arrayOf(_propTypes["default"].instanceOf(_leaflet["default"].LatLng)).isRequired,
  optionIdxFn: _propTypes["default"].func.isRequired,
  options: _propTypes["default"].arrayOf(_propTypes["default"].object.isRequired)
};